import { FC } from "react";
import Container from "@/components/Container";
import { Link } from "react-router-dom";

const NotFound: FC = () => {
  return (
    <Container>
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-dark mb-4 text-6xl font-bold">404</h1>
          <h2 className="mb-2 text-2xl font-semibold">Puslapis nerastas</h2>
          <p className="mb-6 text-gray-600 dark:text-gray-400">
            Atsiprašome, puslapis, kurio ieškote, neegzistuoja.
          </p>
          <Link
            to="/"
            className="bg-dark hover:bg-dark/90 hidden w-full shrink-0 items-center justify-center gap-2.5 rounded-full px-6 py-3.5 text-base font-medium text-white transition-colors md:flex md:w-auto md:px-8 md:py-4"
          >
            Į pagrindinį
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
